/* tslint:disable */
/* eslint-disable */
/**
 * Veritable
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 7.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ClaimSearch } from '../models';
// @ts-ignore
import type { ERAPatchModel } from '../models';
// @ts-ignore
import type { ERAResponseModel } from '../models';
// @ts-ignore
import type { ERASearch } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { PaymentReconciliationModel } from '../models';
// @ts-ignore
import type { PaymentReconciliationModelUpdate } from '../models';
// @ts-ignore
import type { PaymentReconciliationResponseModel } from '../models';
// @ts-ignore
import type { PaymentReconciliationSearch } from '../models';
// @ts-ignore
import type { PaymentReconciliationSource } from '../models';
// @ts-ignore
import type { SearchEraPaymentReconciliations200Response } from '../models';
// @ts-ignore
import type { SearchPaymentReconciliations200Response } from '../models';
/**
 * FHIRPaymentReconciliationApi - axios parameter creator
 * @export
 */
export const FHIRPaymentReconciliationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete a payment reconciliation
         * @summary Delete a payment reconciliation
         * @param {string} paymentReconciliationId 
         * @param {boolean} cancelPayment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePaymentReconciliation: async (paymentReconciliationId: string, cancelPayment: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentReconciliationId' is not null or undefined
            assertParamExists('deletePaymentReconciliation', 'paymentReconciliationId', paymentReconciliationId)
            // verify required parameter 'cancelPayment' is not null or undefined
            assertParamExists('deletePaymentReconciliation', 'cancelPayment', cancelPayment)
            const localVarPath = `/api/v1/fhir/paymentreconciliation/{paymentReconciliationId}`
                .replace(`{${"paymentReconciliationId"}}`, encodeURIComponent(String(paymentReconciliationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (cancelPayment !== undefined) {
                localVarQueryParameter['cancelPayment'] = cancelPayment;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download ERA detail as a PDF file
         * @summary Download ERA detail as PDF
         * @param {string} paymentReconciliationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadEraDetail: async (paymentReconciliationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentReconciliationId' is not null or undefined
            assertParamExists('downloadEraDetail', 'paymentReconciliationId', paymentReconciliationId)
            const localVarPath = `/api/v1/fhir/paymentreconciliation/era/{paymentReconciliationId}/download`
                .replace(`{${"paymentReconciliationId"}}`, encodeURIComponent(String(paymentReconciliationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get ERA payment reconciliation by payment reconciliation Id
         * @summary Get ERA payment reconciliation by payment reconciliation Id
         * @param {string} paymentReconciliationId 
         * @param {ClaimSearch} claimSearch 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEraPaymentReconciliationById: async (paymentReconciliationId: string, claimSearch: ClaimSearch, pgNum?: number, pgSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentReconciliationId' is not null or undefined
            assertParamExists('getEraPaymentReconciliationById', 'paymentReconciliationId', paymentReconciliationId)
            // verify required parameter 'claimSearch' is not null or undefined
            assertParamExists('getEraPaymentReconciliationById', 'claimSearch', claimSearch)
            const localVarPath = `/api/v1/fhir/paymentreconciliation/era/{paymentReconciliationId}`
                .replace(`{${"paymentReconciliationId"}}`, encodeURIComponent(String(paymentReconciliationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (pgNum !== undefined) {
                localVarQueryParameter['pg_num'] = pgNum;
            }

            if (pgSize !== undefined) {
                localVarQueryParameter['pg_size'] = pgSize;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(claimSearch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get payment reconciliation by payment reconciliation id
         * @summary Get a payment reconciliation by payment reconciliation id
         * @param {string} paymentReconciliationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentReconciliation: async (paymentReconciliationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentReconciliationId' is not null or undefined
            assertParamExists('getPaymentReconciliation', 'paymentReconciliationId', paymentReconciliationId)
            const localVarPath = `/api/v1/fhir/paymentreconciliation/{paymentReconciliationId}`
                .replace(`{${"paymentReconciliationId"}}`, encodeURIComponent(String(paymentReconciliationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Patch ERA payment reconciliation
         * @summary Patch ERA payment reconciliation
         * @param {string} paymentReconciliationId 
         * @param {ERAPatchModel} eRAPatchModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEraPaymentReconciliation: async (paymentReconciliationId: string, eRAPatchModel: ERAPatchModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentReconciliationId' is not null or undefined
            assertParamExists('patchEraPaymentReconciliation', 'paymentReconciliationId', paymentReconciliationId)
            // verify required parameter 'eRAPatchModel' is not null or undefined
            assertParamExists('patchEraPaymentReconciliation', 'eRAPatchModel', eRAPatchModel)
            const localVarPath = `/api/v1/fhir/paymentreconciliation/era/{paymentReconciliationId}`
                .replace(`{${"paymentReconciliationId"}}`, encodeURIComponent(String(paymentReconciliationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eRAPatchModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Patch a payment reconciliation
         * @summary Patch a payment reconciliation
         * @param {string} paymentReconciliationId 
         * @param {PaymentReconciliationModelUpdate} paymentReconciliationModelUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchPaymentReconciliation: async (paymentReconciliationId: string, paymentReconciliationModelUpdate: PaymentReconciliationModelUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentReconciliationId' is not null or undefined
            assertParamExists('patchPaymentReconciliation', 'paymentReconciliationId', paymentReconciliationId)
            // verify required parameter 'paymentReconciliationModelUpdate' is not null or undefined
            assertParamExists('patchPaymentReconciliation', 'paymentReconciliationModelUpdate', paymentReconciliationModelUpdate)
            const localVarPath = `/api/v1/fhir/paymentreconciliation/{paymentReconciliationId}`
                .replace(`{${"paymentReconciliationId"}}`, encodeURIComponent(String(paymentReconciliationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(paymentReconciliationModelUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a payment reconciliation
         * @summary Create a payment reconciliation
         * @param {PaymentReconciliationModel} paymentReconciliationModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPaymentReconciliation: async (paymentReconciliationModel: PaymentReconciliationModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentReconciliationModel' is not null or undefined
            assertParamExists('postPaymentReconciliation', 'paymentReconciliationModel', paymentReconciliationModel)
            const localVarPath = `/api/v1/fhir/paymentreconciliation/patientPayment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(paymentReconciliationModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search ERA payment reconciliations
         * @summary Search ERA payment reconciliations
         * @param {ERASearch} eRASearch 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchEraPaymentReconciliations: async (eRASearch: ERASearch, pgNum?: number, pgSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eRASearch' is not null or undefined
            assertParamExists('searchEraPaymentReconciliations', 'eRASearch', eRASearch)
            const localVarPath = `/api/v1/fhir/paymentreconciliation/era/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (pgNum !== undefined) {
                localVarQueryParameter['pg_num'] = pgNum;
            }

            if (pgSize !== undefined) {
                localVarQueryParameter['pg_size'] = pgSize;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eRASearch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search payment reconciliations
         * @summary Search payment reconciliations
         * @param {PaymentReconciliationSource} source 
         * @param {PaymentReconciliationSearch} paymentReconciliationSearch 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPaymentReconciliations: async (source: PaymentReconciliationSource, paymentReconciliationSearch: PaymentReconciliationSearch, pgNum?: number, pgSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'source' is not null or undefined
            assertParamExists('searchPaymentReconciliations', 'source', source)
            // verify required parameter 'paymentReconciliationSearch' is not null or undefined
            assertParamExists('searchPaymentReconciliations', 'paymentReconciliationSearch', paymentReconciliationSearch)
            const localVarPath = `/api/v1/fhir/paymentreconciliation/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            if (pgNum !== undefined) {
                localVarQueryParameter['pg_num'] = pgNum;
            }

            if (pgSize !== undefined) {
                localVarQueryParameter['pg_size'] = pgSize;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(paymentReconciliationSearch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FHIRPaymentReconciliationApi - functional programming interface
 * @export
 */
export const FHIRPaymentReconciliationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FHIRPaymentReconciliationApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete a payment reconciliation
         * @summary Delete a payment reconciliation
         * @param {string} paymentReconciliationId 
         * @param {boolean} cancelPayment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePaymentReconciliation(paymentReconciliationId: string, cancelPayment: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePaymentReconciliation(paymentReconciliationId, cancelPayment, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRPaymentReconciliationApi.deletePaymentReconciliation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Download ERA detail as a PDF file
         * @summary Download ERA detail as PDF
         * @param {string} paymentReconciliationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadEraDetail(paymentReconciliationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadEraDetail(paymentReconciliationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRPaymentReconciliationApi.downloadEraDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get ERA payment reconciliation by payment reconciliation Id
         * @summary Get ERA payment reconciliation by payment reconciliation Id
         * @param {string} paymentReconciliationId 
         * @param {ClaimSearch} claimSearch 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEraPaymentReconciliationById(paymentReconciliationId: string, claimSearch: ClaimSearch, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ERAResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEraPaymentReconciliationById(paymentReconciliationId, claimSearch, pgNum, pgSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRPaymentReconciliationApi.getEraPaymentReconciliationById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get payment reconciliation by payment reconciliation id
         * @summary Get a payment reconciliation by payment reconciliation id
         * @param {string} paymentReconciliationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentReconciliation(paymentReconciliationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentReconciliationResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaymentReconciliation(paymentReconciliationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRPaymentReconciliationApi.getPaymentReconciliation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Patch ERA payment reconciliation
         * @summary Patch ERA payment reconciliation
         * @param {string} paymentReconciliationId 
         * @param {ERAPatchModel} eRAPatchModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEraPaymentReconciliation(paymentReconciliationId: string, eRAPatchModel: ERAPatchModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEraPaymentReconciliation(paymentReconciliationId, eRAPatchModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRPaymentReconciliationApi.patchEraPaymentReconciliation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Patch a payment reconciliation
         * @summary Patch a payment reconciliation
         * @param {string} paymentReconciliationId 
         * @param {PaymentReconciliationModelUpdate} paymentReconciliationModelUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchPaymentReconciliation(paymentReconciliationId: string, paymentReconciliationModelUpdate: PaymentReconciliationModelUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentReconciliationResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchPaymentReconciliation(paymentReconciliationId, paymentReconciliationModelUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRPaymentReconciliationApi.patchPaymentReconciliation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a payment reconciliation
         * @summary Create a payment reconciliation
         * @param {PaymentReconciliationModel} paymentReconciliationModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postPaymentReconciliation(paymentReconciliationModel: PaymentReconciliationModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentReconciliationResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postPaymentReconciliation(paymentReconciliationModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRPaymentReconciliationApi.postPaymentReconciliation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search ERA payment reconciliations
         * @summary Search ERA payment reconciliations
         * @param {ERASearch} eRASearch 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchEraPaymentReconciliations(eRASearch: ERASearch, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchEraPaymentReconciliations200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchEraPaymentReconciliations(eRASearch, pgNum, pgSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRPaymentReconciliationApi.searchEraPaymentReconciliations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search payment reconciliations
         * @summary Search payment reconciliations
         * @param {PaymentReconciliationSource} source 
         * @param {PaymentReconciliationSearch} paymentReconciliationSearch 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchPaymentReconciliations(source: PaymentReconciliationSource, paymentReconciliationSearch: PaymentReconciliationSearch, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchPaymentReconciliations200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchPaymentReconciliations(source, paymentReconciliationSearch, pgNum, pgSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRPaymentReconciliationApi.searchPaymentReconciliations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FHIRPaymentReconciliationApi - factory interface
 * @export
 */
export const FHIRPaymentReconciliationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FHIRPaymentReconciliationApiFp(configuration)
    return {
        /**
         * Delete a payment reconciliation
         * @summary Delete a payment reconciliation
         * @param {FHIRPaymentReconciliationApiDeletePaymentReconciliationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePaymentReconciliation(requestParameters: FHIRPaymentReconciliationApiDeletePaymentReconciliationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePaymentReconciliation(requestParameters.paymentReconciliationId, requestParameters.cancelPayment, options).then((request) => request(axios, basePath));
        },
        /**
         * Download ERA detail as a PDF file
         * @summary Download ERA detail as PDF
         * @param {FHIRPaymentReconciliationApiDownloadEraDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadEraDetail(requestParameters: FHIRPaymentReconciliationApiDownloadEraDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadEraDetail(requestParameters.paymentReconciliationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get ERA payment reconciliation by payment reconciliation Id
         * @summary Get ERA payment reconciliation by payment reconciliation Id
         * @param {FHIRPaymentReconciliationApiGetEraPaymentReconciliationByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEraPaymentReconciliationById(requestParameters: FHIRPaymentReconciliationApiGetEraPaymentReconciliationByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<ERAResponseModel> {
            return localVarFp.getEraPaymentReconciliationById(requestParameters.paymentReconciliationId, requestParameters.claimSearch, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Get payment reconciliation by payment reconciliation id
         * @summary Get a payment reconciliation by payment reconciliation id
         * @param {FHIRPaymentReconciliationApiGetPaymentReconciliationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentReconciliation(requestParameters: FHIRPaymentReconciliationApiGetPaymentReconciliationRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaymentReconciliationResponseModel> {
            return localVarFp.getPaymentReconciliation(requestParameters.paymentReconciliationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Patch ERA payment reconciliation
         * @summary Patch ERA payment reconciliation
         * @param {FHIRPaymentReconciliationApiPatchEraPaymentReconciliationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEraPaymentReconciliation(requestParameters: FHIRPaymentReconciliationApiPatchEraPaymentReconciliationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.patchEraPaymentReconciliation(requestParameters.paymentReconciliationId, requestParameters.eRAPatchModel, options).then((request) => request(axios, basePath));
        },
        /**
         * Patch a payment reconciliation
         * @summary Patch a payment reconciliation
         * @param {FHIRPaymentReconciliationApiPatchPaymentReconciliationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchPaymentReconciliation(requestParameters: FHIRPaymentReconciliationApiPatchPaymentReconciliationRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaymentReconciliationResponseModel> {
            return localVarFp.patchPaymentReconciliation(requestParameters.paymentReconciliationId, requestParameters.paymentReconciliationModelUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a payment reconciliation
         * @summary Create a payment reconciliation
         * @param {FHIRPaymentReconciliationApiPostPaymentReconciliationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPaymentReconciliation(requestParameters: FHIRPaymentReconciliationApiPostPaymentReconciliationRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaymentReconciliationResponseModel> {
            return localVarFp.postPaymentReconciliation(requestParameters.paymentReconciliationModel, options).then((request) => request(axios, basePath));
        },
        /**
         * Search ERA payment reconciliations
         * @summary Search ERA payment reconciliations
         * @param {FHIRPaymentReconciliationApiSearchEraPaymentReconciliationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchEraPaymentReconciliations(requestParameters: FHIRPaymentReconciliationApiSearchEraPaymentReconciliationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SearchEraPaymentReconciliations200Response> {
            return localVarFp.searchEraPaymentReconciliations(requestParameters.eRASearch, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Search payment reconciliations
         * @summary Search payment reconciliations
         * @param {FHIRPaymentReconciliationApiSearchPaymentReconciliationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPaymentReconciliations(requestParameters: FHIRPaymentReconciliationApiSearchPaymentReconciliationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SearchPaymentReconciliations200Response> {
            return localVarFp.searchPaymentReconciliations(requestParameters.source, requestParameters.paymentReconciliationSearch, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FHIRPaymentReconciliationApi - interface
 * @export
 * @interface FHIRPaymentReconciliationApi
 */
export interface FHIRPaymentReconciliationApiInterface {
    /**
     * Delete a payment reconciliation
     * @summary Delete a payment reconciliation
     * @param {FHIRPaymentReconciliationApiDeletePaymentReconciliationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRPaymentReconciliationApiInterface
     */
    deletePaymentReconciliation(requestParameters: FHIRPaymentReconciliationApiDeletePaymentReconciliationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Download ERA detail as a PDF file
     * @summary Download ERA detail as PDF
     * @param {FHIRPaymentReconciliationApiDownloadEraDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRPaymentReconciliationApiInterface
     */
    downloadEraDetail(requestParameters: FHIRPaymentReconciliationApiDownloadEraDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * Get ERA payment reconciliation by payment reconciliation Id
     * @summary Get ERA payment reconciliation by payment reconciliation Id
     * @param {FHIRPaymentReconciliationApiGetEraPaymentReconciliationByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRPaymentReconciliationApiInterface
     */
    getEraPaymentReconciliationById(requestParameters: FHIRPaymentReconciliationApiGetEraPaymentReconciliationByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<ERAResponseModel>;

    /**
     * Get payment reconciliation by payment reconciliation id
     * @summary Get a payment reconciliation by payment reconciliation id
     * @param {FHIRPaymentReconciliationApiGetPaymentReconciliationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRPaymentReconciliationApiInterface
     */
    getPaymentReconciliation(requestParameters: FHIRPaymentReconciliationApiGetPaymentReconciliationRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaymentReconciliationResponseModel>;

    /**
     * Patch ERA payment reconciliation
     * @summary Patch ERA payment reconciliation
     * @param {FHIRPaymentReconciliationApiPatchEraPaymentReconciliationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRPaymentReconciliationApiInterface
     */
    patchEraPaymentReconciliation(requestParameters: FHIRPaymentReconciliationApiPatchEraPaymentReconciliationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Patch a payment reconciliation
     * @summary Patch a payment reconciliation
     * @param {FHIRPaymentReconciliationApiPatchPaymentReconciliationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRPaymentReconciliationApiInterface
     */
    patchPaymentReconciliation(requestParameters: FHIRPaymentReconciliationApiPatchPaymentReconciliationRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaymentReconciliationResponseModel>;

    /**
     * Create a payment reconciliation
     * @summary Create a payment reconciliation
     * @param {FHIRPaymentReconciliationApiPostPaymentReconciliationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRPaymentReconciliationApiInterface
     */
    postPaymentReconciliation(requestParameters: FHIRPaymentReconciliationApiPostPaymentReconciliationRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaymentReconciliationResponseModel>;

    /**
     * Search ERA payment reconciliations
     * @summary Search ERA payment reconciliations
     * @param {FHIRPaymentReconciliationApiSearchEraPaymentReconciliationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRPaymentReconciliationApiInterface
     */
    searchEraPaymentReconciliations(requestParameters: FHIRPaymentReconciliationApiSearchEraPaymentReconciliationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SearchEraPaymentReconciliations200Response>;

    /**
     * Search payment reconciliations
     * @summary Search payment reconciliations
     * @param {FHIRPaymentReconciliationApiSearchPaymentReconciliationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRPaymentReconciliationApiInterface
     */
    searchPaymentReconciliations(requestParameters: FHIRPaymentReconciliationApiSearchPaymentReconciliationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SearchPaymentReconciliations200Response>;

}

/**
 * Request parameters for deletePaymentReconciliation operation in FHIRPaymentReconciliationApi.
 * @export
 * @interface FHIRPaymentReconciliationApiDeletePaymentReconciliationRequest
 */
export interface FHIRPaymentReconciliationApiDeletePaymentReconciliationRequest {
    /**
     * 
     * @type {string}
     * @memberof FHIRPaymentReconciliationApiDeletePaymentReconciliation
     */
    readonly paymentReconciliationId: string

    /**
     * 
     * @type {boolean}
     * @memberof FHIRPaymentReconciliationApiDeletePaymentReconciliation
     */
    readonly cancelPayment: boolean
}

/**
 * Request parameters for downloadEraDetail operation in FHIRPaymentReconciliationApi.
 * @export
 * @interface FHIRPaymentReconciliationApiDownloadEraDetailRequest
 */
export interface FHIRPaymentReconciliationApiDownloadEraDetailRequest {
    /**
     * 
     * @type {string}
     * @memberof FHIRPaymentReconciliationApiDownloadEraDetail
     */
    readonly paymentReconciliationId: string
}

/**
 * Request parameters for getEraPaymentReconciliationById operation in FHIRPaymentReconciliationApi.
 * @export
 * @interface FHIRPaymentReconciliationApiGetEraPaymentReconciliationByIdRequest
 */
export interface FHIRPaymentReconciliationApiGetEraPaymentReconciliationByIdRequest {
    /**
     * 
     * @type {string}
     * @memberof FHIRPaymentReconciliationApiGetEraPaymentReconciliationById
     */
    readonly paymentReconciliationId: string

    /**
     * 
     * @type {ClaimSearch}
     * @memberof FHIRPaymentReconciliationApiGetEraPaymentReconciliationById
     */
    readonly claimSearch: ClaimSearch

    /**
     * 
     * @type {number}
     * @memberof FHIRPaymentReconciliationApiGetEraPaymentReconciliationById
     */
    readonly pgNum?: number

    /**
     * 
     * @type {number}
     * @memberof FHIRPaymentReconciliationApiGetEraPaymentReconciliationById
     */
    readonly pgSize?: number
}

/**
 * Request parameters for getPaymentReconciliation operation in FHIRPaymentReconciliationApi.
 * @export
 * @interface FHIRPaymentReconciliationApiGetPaymentReconciliationRequest
 */
export interface FHIRPaymentReconciliationApiGetPaymentReconciliationRequest {
    /**
     * 
     * @type {string}
     * @memberof FHIRPaymentReconciliationApiGetPaymentReconciliation
     */
    readonly paymentReconciliationId: string
}

/**
 * Request parameters for patchEraPaymentReconciliation operation in FHIRPaymentReconciliationApi.
 * @export
 * @interface FHIRPaymentReconciliationApiPatchEraPaymentReconciliationRequest
 */
export interface FHIRPaymentReconciliationApiPatchEraPaymentReconciliationRequest {
    /**
     * 
     * @type {string}
     * @memberof FHIRPaymentReconciliationApiPatchEraPaymentReconciliation
     */
    readonly paymentReconciliationId: string

    /**
     * 
     * @type {ERAPatchModel}
     * @memberof FHIRPaymentReconciliationApiPatchEraPaymentReconciliation
     */
    readonly eRAPatchModel: ERAPatchModel
}

/**
 * Request parameters for patchPaymentReconciliation operation in FHIRPaymentReconciliationApi.
 * @export
 * @interface FHIRPaymentReconciliationApiPatchPaymentReconciliationRequest
 */
export interface FHIRPaymentReconciliationApiPatchPaymentReconciliationRequest {
    /**
     * 
     * @type {string}
     * @memberof FHIRPaymentReconciliationApiPatchPaymentReconciliation
     */
    readonly paymentReconciliationId: string

    /**
     * 
     * @type {PaymentReconciliationModelUpdate}
     * @memberof FHIRPaymentReconciliationApiPatchPaymentReconciliation
     */
    readonly paymentReconciliationModelUpdate: PaymentReconciliationModelUpdate
}

/**
 * Request parameters for postPaymentReconciliation operation in FHIRPaymentReconciliationApi.
 * @export
 * @interface FHIRPaymentReconciliationApiPostPaymentReconciliationRequest
 */
export interface FHIRPaymentReconciliationApiPostPaymentReconciliationRequest {
    /**
     * 
     * @type {PaymentReconciliationModel}
     * @memberof FHIRPaymentReconciliationApiPostPaymentReconciliation
     */
    readonly paymentReconciliationModel: PaymentReconciliationModel
}

/**
 * Request parameters for searchEraPaymentReconciliations operation in FHIRPaymentReconciliationApi.
 * @export
 * @interface FHIRPaymentReconciliationApiSearchEraPaymentReconciliationsRequest
 */
export interface FHIRPaymentReconciliationApiSearchEraPaymentReconciliationsRequest {
    /**
     * 
     * @type {ERASearch}
     * @memberof FHIRPaymentReconciliationApiSearchEraPaymentReconciliations
     */
    readonly eRASearch: ERASearch

    /**
     * 
     * @type {number}
     * @memberof FHIRPaymentReconciliationApiSearchEraPaymentReconciliations
     */
    readonly pgNum?: number

    /**
     * 
     * @type {number}
     * @memberof FHIRPaymentReconciliationApiSearchEraPaymentReconciliations
     */
    readonly pgSize?: number
}

/**
 * Request parameters for searchPaymentReconciliations operation in FHIRPaymentReconciliationApi.
 * @export
 * @interface FHIRPaymentReconciliationApiSearchPaymentReconciliationsRequest
 */
export interface FHIRPaymentReconciliationApiSearchPaymentReconciliationsRequest {
    /**
     * 
     * @type {PaymentReconciliationSource}
     * @memberof FHIRPaymentReconciliationApiSearchPaymentReconciliations
     */
    readonly source: PaymentReconciliationSource

    /**
     * 
     * @type {PaymentReconciliationSearch}
     * @memberof FHIRPaymentReconciliationApiSearchPaymentReconciliations
     */
    readonly paymentReconciliationSearch: PaymentReconciliationSearch

    /**
     * 
     * @type {number}
     * @memberof FHIRPaymentReconciliationApiSearchPaymentReconciliations
     */
    readonly pgNum?: number

    /**
     * 
     * @type {number}
     * @memberof FHIRPaymentReconciliationApiSearchPaymentReconciliations
     */
    readonly pgSize?: number
}

/**
 * FHIRPaymentReconciliationApi - object-oriented interface
 * @export
 * @class FHIRPaymentReconciliationApi
 * @extends {BaseAPI}
 */
export class FHIRPaymentReconciliationApi extends BaseAPI implements FHIRPaymentReconciliationApiInterface {
    /**
     * Delete a payment reconciliation
     * @summary Delete a payment reconciliation
     * @param {FHIRPaymentReconciliationApiDeletePaymentReconciliationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRPaymentReconciliationApi
     */
    public deletePaymentReconciliation(requestParameters: FHIRPaymentReconciliationApiDeletePaymentReconciliationRequest, options?: RawAxiosRequestConfig) {
        return FHIRPaymentReconciliationApiFp(this.configuration).deletePaymentReconciliation(requestParameters.paymentReconciliationId, requestParameters.cancelPayment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download ERA detail as a PDF file
     * @summary Download ERA detail as PDF
     * @param {FHIRPaymentReconciliationApiDownloadEraDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRPaymentReconciliationApi
     */
    public downloadEraDetail(requestParameters: FHIRPaymentReconciliationApiDownloadEraDetailRequest, options?: RawAxiosRequestConfig) {
        return FHIRPaymentReconciliationApiFp(this.configuration).downloadEraDetail(requestParameters.paymentReconciliationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get ERA payment reconciliation by payment reconciliation Id
     * @summary Get ERA payment reconciliation by payment reconciliation Id
     * @param {FHIRPaymentReconciliationApiGetEraPaymentReconciliationByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRPaymentReconciliationApi
     */
    public getEraPaymentReconciliationById(requestParameters: FHIRPaymentReconciliationApiGetEraPaymentReconciliationByIdRequest, options?: RawAxiosRequestConfig) {
        return FHIRPaymentReconciliationApiFp(this.configuration).getEraPaymentReconciliationById(requestParameters.paymentReconciliationId, requestParameters.claimSearch, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get payment reconciliation by payment reconciliation id
     * @summary Get a payment reconciliation by payment reconciliation id
     * @param {FHIRPaymentReconciliationApiGetPaymentReconciliationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRPaymentReconciliationApi
     */
    public getPaymentReconciliation(requestParameters: FHIRPaymentReconciliationApiGetPaymentReconciliationRequest, options?: RawAxiosRequestConfig) {
        return FHIRPaymentReconciliationApiFp(this.configuration).getPaymentReconciliation(requestParameters.paymentReconciliationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Patch ERA payment reconciliation
     * @summary Patch ERA payment reconciliation
     * @param {FHIRPaymentReconciliationApiPatchEraPaymentReconciliationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRPaymentReconciliationApi
     */
    public patchEraPaymentReconciliation(requestParameters: FHIRPaymentReconciliationApiPatchEraPaymentReconciliationRequest, options?: RawAxiosRequestConfig) {
        return FHIRPaymentReconciliationApiFp(this.configuration).patchEraPaymentReconciliation(requestParameters.paymentReconciliationId, requestParameters.eRAPatchModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Patch a payment reconciliation
     * @summary Patch a payment reconciliation
     * @param {FHIRPaymentReconciliationApiPatchPaymentReconciliationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRPaymentReconciliationApi
     */
    public patchPaymentReconciliation(requestParameters: FHIRPaymentReconciliationApiPatchPaymentReconciliationRequest, options?: RawAxiosRequestConfig) {
        return FHIRPaymentReconciliationApiFp(this.configuration).patchPaymentReconciliation(requestParameters.paymentReconciliationId, requestParameters.paymentReconciliationModelUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a payment reconciliation
     * @summary Create a payment reconciliation
     * @param {FHIRPaymentReconciliationApiPostPaymentReconciliationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRPaymentReconciliationApi
     */
    public postPaymentReconciliation(requestParameters: FHIRPaymentReconciliationApiPostPaymentReconciliationRequest, options?: RawAxiosRequestConfig) {
        return FHIRPaymentReconciliationApiFp(this.configuration).postPaymentReconciliation(requestParameters.paymentReconciliationModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search ERA payment reconciliations
     * @summary Search ERA payment reconciliations
     * @param {FHIRPaymentReconciliationApiSearchEraPaymentReconciliationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRPaymentReconciliationApi
     */
    public searchEraPaymentReconciliations(requestParameters: FHIRPaymentReconciliationApiSearchEraPaymentReconciliationsRequest, options?: RawAxiosRequestConfig) {
        return FHIRPaymentReconciliationApiFp(this.configuration).searchEraPaymentReconciliations(requestParameters.eRASearch, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search payment reconciliations
     * @summary Search payment reconciliations
     * @param {FHIRPaymentReconciliationApiSearchPaymentReconciliationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRPaymentReconciliationApi
     */
    public searchPaymentReconciliations(requestParameters: FHIRPaymentReconciliationApiSearchPaymentReconciliationsRequest, options?: RawAxiosRequestConfig) {
        return FHIRPaymentReconciliationApiFp(this.configuration).searchPaymentReconciliations(requestParameters.source, requestParameters.paymentReconciliationSearch, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(this.axios, this.basePath));
    }
}

